import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { PAYMENT_METHOD_AADE_CODE } from '../../../interfaces/paymentTypes.interface';

interface Props {
  doc: InvoiceInterface;
}

export const DocViewNotes = ({ doc }: Props) => {
  const { t } = useTranslation();

  const getPosTransactionDetails = useCallback(() => {
    if (
      doc?.post_with_provider &&
      doc?.paymentType?.aadeCode === PAYMENT_METHOD_AADE_CODE.POS &&
      doc?.latestPayment?.posTransactionDetails
    ) {
      return (
        <>
          <div className="normalText8px">
            {t('PDF.POS_PAYMENT_ID')}: {doc?.latestPayment?.posTransactionDetails?.transactionId}
            {' - '}
            {t('PDF.POS_PAYMENT_SIGNATURE')}: {doc?.latestPayment?.posTransactionDetails?.provider_signature}
          </div>
        </>
      );
    }
  }, [doc?.latestPayment?.posTransactionDetails, doc?.paymentType?.aadeCode, doc?.post_with_provider, t]);

  return (
    <div className="notesSection">
      <div className="notesTitle">
        <div className="normalText2 padding-l-4">{t('PDF.NOTES')}</div>
      </div>
      <div className="padding-l-4 padding-t-4">
        <div className="normalText2">{doc?.notes}</div>
        {getPosTransactionDetails()}
      </div>
    </div>
  );
};
